import { NUU_COOKIE_NOTIFICATIONS } from '~coreModules/core/js/cookie-constants';
import { SECONDS_IN_1_DAY } from '~coreModules/core/js/date-constants';
import {
    ANONYMOUS_NOTIFICATIONS,
    AUTHENTICATED_NOTIFICATIONS,
    NOTIFICATION_IDS,
} from '~coreModules/notifications/js/notifications-constants';

import { SITE_SETTINGS_MODULE_NAME } from '~coreModules/site-settings/js/site-settings-store';

import { isNotificationPageBlocked, filterNotifications } from '~coreModules/notifications/js/notifications-utils';

export const NOTIFICATIONS_MODULE_NAME = 'notifications';
export const SET_NOTIFICATION_VIEWED = 'SET_NOTIFICATION_VIEWED';
export const SET_ELIGIBLE_NOTIFICATIONS = 'SET_ELIGIBLE_NOTIFICATIONS';
export const GET_ELIGIBLE_NOTIFICATIONS = 'GET_ELIGIBLE_NOTIFICATIONS';

export default {
    namespaced: true,

    state: () => ({
        eligibleNotifications: [],
    }),

    /* eslint-disable no-param-reassign */
    mutations: {
        [SET_ELIGIBLE_NOTIFICATIONS](state, eligibleNotifications) {
            state.eligibleNotifications = eligibleNotifications;
        },
    },
    /* eslint-enable */

    actions: {
        [GET_ELIGIBLE_NOTIFICATIONS]({ commit, rootGetters }) {
            let notifications = rootGetters[`${SITE_SETTINGS_MODULE_NAME}/notifications`];

            // filter notifications that are eligible
            const allowedNotifications =
                rootGetters.loggedIn ? AUTHENTICATED_NOTIFICATIONS : ANONYMOUS_NOTIFICATIONS;

            notifications = filterNotifications(notifications, allowedNotifications, this.$cookies);

            commit(SET_ELIGIBLE_NOTIFICATIONS, notifications);
        },
        [SET_NOTIFICATION_VIEWED]({ commit, state }, {
            notificationId,
            daysToExpiration,
            shouldTrackView = true,
            clearNotifications = false,
        }) {
            if (shouldTrackView && daysToExpiration) {
                this.$cookies.set(
                    `${NUU_COOKIE_NOTIFICATIONS}_${notificationId}`,
                    true,
                    { maxAge: daysToExpiration * SECONDS_IN_1_DAY },
                );
            }

            if (clearNotifications) {
                commit(SET_ELIGIBLE_NOTIFICATIONS, []);
            } else {
                const eligibleNotifications = state.eligibleNotifications.filter(
                    notification => notification.notificationId !== notificationId);

                commit(SET_ELIGIBLE_NOTIFICATIONS, eligibleNotifications);
            }
        },
    },
    getters: {
        activeAnonymousModalNotification(state) {
            return routePath => state.eligibleNotifications?.find(notification => (
                !isNotificationPageBlocked(routePath, notification)
            ));
        },
        activeFitFeedbackNotification(state) {
            return routePath => state.eligibleNotifications?.find(notification => (
                notification.notificationId === NOTIFICATION_IDS.FIT_FEEDBACK &&
                !isNotificationPageBlocked(routePath, notification)
            ));
        },
    },
};
